import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadLicensePlateNLCustomerCounterBuyCar,
  conversationalLpFlowWithoutConsent,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseConversationalLeadPage
      form={conversationalLpFlowWithoutConsent}
      manualForm={
        <CarleadLicensePlateNLCustomerCounterBuyCar showPricedCounter={false} />
      }
      content={CarleadHIWWhyChooseWkdaFaq}
      headlineDesktop="carleadCreation.form.title"
      showTrustPilotInChat={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
